import { render, staticRenderFns } from "./BlogOne.vue?vue&type=template&id=23562129&"
import script from "./BlogOne.vue?vue&type=script&lang=js&"
export * from "./BlogOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23562129')) {
      api.createRecord('23562129', component.options)
    } else {
      api.reload('23562129', component.options)
    }
    module.hot.accept("./BlogOne.vue?vue&type=template&id=23562129&", function () {
      api.rerender('23562129', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/blogs/BlogOne.vue"
export default component.exports